import { render, staticRenderFns } from "./oilRecoveryBackMoney.vue?vue&type=template&id=3c38b5ed&scoped=true"
import script from "./oilRecoveryBackMoney.vue?vue&type=script&lang=js"
export * from "./oilRecoveryBackMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38b5ed",
  null
  
)

export default component.exports